// Provides a barebones Intl.Collator on Safari 9 and JavaFX, to prevent the world from ending.
const global = window;
if (!global.Intl) {
    global.Intl = {};
}

if (!global.Intl.Collator) {
    global.Intl.Collator = function() {
        this.compare = function(a, b) {
            return (''+a).localeCompare(b);
        }
        this.resolvedOptions = () => ({
            locale: 'en-US',
            usage: 'sort',
            sensitivity: 'variant',
            ignorePunctuation: false,
            collation: 'default'
        });
    }
}
